import { faXmark, faBars } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import { MenuCenterIcon, MenuIconContainer, MenuIconImageContainer } from './MenuIcon.styled';
import LeftBracket from '../../../../assets/icons/current_cycle_left.svg?react';
import RightBracket from '../../../../assets/icons/current_cycle_right.svg?react';

import { MenuIconProps } from './MenuIcon.types';

export const MenuIcon = ({ toggleMenu, isOpen }: MenuIconProps) => {
  const menuButtonLabel = isOpen ? 'Close menu' : 'Open menu';

  return (
    <MenuIconContainer>
      <MenuIconImageContainer
        type="button"
        aria-label={menuButtonLabel}
        aria-expanded={isOpen}
        onClick={toggleMenu}
      >
        <LeftBracket height={34} width={13} id="menu-icon-left-bracket" />
        <MenuCenterIcon>
          {isOpen ? (
            <FontAwesomeIcon icon={faXmark} aria-hidden={true} />
          ) : (
            <FontAwesomeIcon icon={faBars} aria-hidden={true} />
          )}
        </MenuCenterIcon>
        <RightBracket height={34} width={13} id="menu-icon-right-bracket" />
      </MenuIconImageContainer>
    </MenuIconContainer>
  );
};
